<template>
    <admin-layout class="canvas" v-if="is_ready" :show-sidebar="false" :show-navbar="true" mainPage="learning-path">

        <div class="scroller">
            <div class="dots">
                <a :href="`#${stage}`" class="dot" v-for="stage in _$$path.stages" :key="stage">
                    <span :style="{ backgroundColor: _$$path[`stage_${stage}_config`].color }"
                        class="inner text-light"></span>
                </a>
            </div>
        </div>

        <!-- <pre style="position: fixed; top: 0; left: 0; background: rgba(255, 255, 255, 0.9); padding: 1rem; z-index: 999;">{{ {unlock_mission, unlock_stage, status_code} }}</pre> -->

        <app-content-pane class="ml-3">
            <template #title>
                <div class="px-4 pt-3">
                    <h1 class="mb-2">
                        {{ project ? project.name : path.name }}
                        <span class="text-muted mr-1">/</span>
                        <span class="text-info">Canvas Preview</span>
                    </h1>
                </div>
                <div v-if="current_user_is_free" class="subscribe-button-holder">
                    <a href="https://www.designforchange.us/contact-us" target="_new"
                        class="btn btn-danger mr-0 mr-lg-5">
                        <img src="/images/icons/archive-light.svg" class="mr-1" alt="">
                        This feature is part of the School Subscription. Contact Us for more details.
                    </a>
                </div>
                <hr class="mb-0">
            </template>

            <section>
                <div class="bg-dark text-light px-3 py-3 d-flex align-items-center">
                    <p class="mb-0 mr-1">This is a preview of student canvas.</p>
                    <template v-if="project">
                        <inertia-link :href="route('project.teams', { project: project.id, ...global_url_params })"
                            class="btn btn-light ml-auto">Invite Students</inertia-link>
                    </template>
                    <template v-else>
                        <inertia-link v-if="current_user_is_paid"
                            :href="route('project.create', { path: path.id, ...global_url_params })"
                            class="btn btn-light ml-auto">Use this template</inertia-link>
                    </template>
                </div>
            </section>

            <canvas-section v-for="stage in _$$path.stages" :key="stage" :id="stage" :locked="false"
                :head-bg="_$$path[`stage_${stage}_config`].color" class="mb-4">
                <template #title>{{ _$$path[`stage_${stage}_config`].name }}</template>
                <template #actions>
                    <!--                    <button class="btn btn-light ml-2">Publish</button>-->
                </template>

                <div class="p-4">
                    <div class="row align-items-stretch">

                        <!-- Stage Mission -->
                        <div class="col-md-12 d-flex flex-column">

                            <h5 class="font-weight-bold">Stage Mission</h5>
                            <canvas-stage-mission :stage="stage" :locked="false" :project="project" :path="repos.path" />
                        </div>
                    </div>

                    <canvas-combined-activities v-for="section in _$$path[`stage_${stage}_activity_sections`]"
                        :key="section.id" :stage="stage" :path-repo="repos.path" :section="section" class="mb-5" />

                    <canvas-deliverable class="mb-5" :path="repos.path" :stage="stage" :locked="false"
                        @update="syncLocking()" />

                </div>

            </canvas-section>

        </app-content-pane>
    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import CanvasSection from "@/Components/Canvas/CanvasSection";
import CanvasToolbox from "@/Components/Toolbox/CanvasToolbox";
import CanvasCombinedActivities from "@/Components/Canvas/CanvasCombinedActivities";
import CanvasStageMission from "@/Components/Canvas/CanvasStageMission";
import CanvasDeliverable from "@/Components/Canvas/CanvasDeliverable";
import { mapActions } from "vuex";
import API from "@/API";
import utils from "@/mixins/utils";

export default {
    name: "Canvas",
    components: {
        AdminLayout,
        AppContentPane,
        CanvasCombinedActivities,
        CanvasDeliverable,
        CanvasSection,
        CanvasStageMission,
        CanvasToolbox,
    },
    props: ['project', 'path'],
    mixins: [utils],

    data() {
        return {

            // stage_uploads: {},

            is_ready: false,
            activities: [],
            stage_locked: {
                intro: false,
                feel: true,
                imagine: true,
                do: true,
                share: true,
            },
            stage_mission_locked: {
                intro: true,
                feel: true,
                imagine: true,
                do: true,
                share: true,
            },

            repos: {
                path: {
                    scope: {
                        name: API.fragments.SCOPE_LEARNING_PATH,
                        id: this.project ? this.project.learning_path.id : this.path.id
                    },
                    fragments: null,
                },
            },
        }
    },

    computed: {
        _$$path() {
            return this.repos.path.fragments;
        },

        // TODO: TEST CODE:
        status_code() {
            const code = {};
            for (const i in this.stage_mission_locked) {
                code[i] = {
                    mission_locked: this.stage_mission_locked[i],
                    stage_locked: this.stage_locked[i],
                }
            }
            return code;
        },

        unlock_mission() {
            if (this.project?.meta['unlock_mission']) return this.project.meta['unlock_mission'];
            return 'one';
        },

        unlock_stage() {
            if (this.project?.meta['unlock_stage']) return this.project.meta['unlock_stage'];
            return 'one';
        },


    },

    watch: {
    },

    methods: {

        ...mapActions('repositories', {
            repo: 'getRepository',
            freeRepo: 'freeRepository',
            updateRepo: 'updateRepository',
        }),

        async initRepos() {
            for (const key in this.repos) {
                if (!this.repos.hasOwnProperty(key)) continue;
                this.repos[key].fragments = (await this.repo(this.repos[key].scope)).fragments;
            }
        },

        isStageMissionLocked(stage) {
            return typeof this.stage_mission_locked[stage] !== 'undefined' ? this.stage_mission_locked[stage] : true;
        },

        isStageLocked(stage) {
            return typeof this.stage_locked[stage] !== 'undefined' ? this.stage_locked[stage] : true
        },

        getCanvasUploadsOfStage(stage) {
            let uploads = [];
            const stage_activities = this.activities.filter(a => a.stage === stage);
            for (const i in stage_activities) {
                if (!stage_activities.hasOwnProperty(i)) continue;
                const section_id = stage_activities[i].section_id;
                const section_uploads = this._$$canvas[`canvas_upload_${stage}_${section_id}`]
                uploads = uploads.concat(section_uploads);
            }
            return uploads;
        },

        updateStageMissionLocking() {
            if (!this._$$path.stages) return;

            for (const i in this._$$path.stages) {
                if (!this._$$path.stages.hasOwnProperty(i)) continue;

                const stage = this._$$path.stages[i];
                const uploads = this.getCanvasUploadsOfStage(stage);

                switch (this.unlock_mission) {
                    case 'never':
                        this.stage_mission_locked[stage] = false;
                        break;
                    case 'one':
                        this.stage_mission_locked[stage] = uploads.length <= 0;
                        break;
                }

            }
        },

        hasDeliverable(stage) {
            // if( (typeof this._$$canvas[`stage_${stage}_mission_deliverable`] !== 'undefined') && !!( this._$$canvas[`stage_${stage}_mission_deliverable`] ) ){
            //     const deliverable = this._$$canvas[`stage_${stage}_mission_deliverable`];
            //     return !!deliverable?.file?.url || !!deliverable?.text;
            // }
            return false;
        },

        updateStageLocking() {
            if (!this._$$path.stages) return;


            console.log('UPDATE STAGE LOCKING');


            let previous_stage = null;
            for (const i in this._$$path.stages) {
                if (!this._$$path.stages.hasOwnProperty(i)) continue;
                const stage = this._$$path.stages[i];

                if (!previous_stage) {
                    previous_stage = stage;
                    this.stage_locked[previous_stage] = false;
                    continue;
                }


                const previous_stage_mission_is_locked = this.isStageMissionLocked(previous_stage);
                const previous_stage_has_deliverable = this.hasDeliverable(previous_stage);
                const previous_stage_uploads = this.getCanvasUploadsOfStage(previous_stage);

                let stage_locked = false;
                switch (this.unlock_stage) {
                    case 'previous-deliverable':
                        stage_locked = previous_stage_mission_is_locked || !previous_stage_has_deliverable;
                        break;

                    case 'previous-one-activity':
                        stage_locked = previous_stage_uploads.length <= 0;
                        break;

                    case 'always':
                        break;
                }

                this.stage_locked[stage] = stage_locked;
                previous_stage = stage;
            }
        },


        activitiesUpdated(stage, section, elements) {
            const activities = elements
                .filter(e => e.element.type === 'activity')
                .map(e => ({
                    stage,
                    id: e.id,
                    section_id: section.id,
                    canvas_key: `canvas_${section.id}_activity_${e.id}_upload`,
                }));

            this.activities = this.activities.concat(activities);

            this.syncLocking();
        },

        syncLocking() {
            this.updateStageMissionLocking();
            this.updateStageLocking();
        }

    },

    async mounted() {
        await this.initRepos();
        this.syncLocking();
        this.is_ready = true;

        if (this.project) {
            this.setTitle(`${this.project.name} / Canvas Preview`);
        } else {
            this.setTitle(`${this.path.name} / Canvas Preview`);
        }

    }

}
</script>

<style lang="scss" scoped>
.excess-mt {
    margin-top: -3em;
}

@media (min-width: 650px) and (max-width: 900px) {
    .excess-mt {
        margin-top: 0.5rem;
        width: 100%;
    }
}

.scroller {
    position: sticky;
    top: 100px;
    z-index: 1;

    .dots {
        position: absolute;
        left: 8px;
        display: flex;
        flex-direction: column;
        background: white;
        padding: 2px;
        box-shadow: 0 0 3px #00000029;
        ;
        border: $light-borders solid 1px;
        border-radius: 10px;
        justify-content: space-between;
        height: 58px;
    }

    .dot {
        display: block;
        border-radius: 50%;

        .inner {
            display: block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
        }
    }
}

.achievement-step {
    display: flex;

    .icon {
        flex: 0 0 20px;
        margin-right: 0.6rem;
    }

    .details {
        flex-grow: 1;
    }
}

.achievement-ribbons {
    display: flex;

    .ribbon {
        margin-right: 0.3rem;
        margin-bottom: 0.3rem;
    }
}


.achievement-progress {
    border-radius: 8px;
    border: $light-borders solid 1px;
    background: white;

    .inner-bar {
        height: 7px;
        border-radius: 8px;
        background: $success;
    }
}


.mission-question {
    margin-bottom: 1.2rem;

    &:last-child {
        margin-bottom: 0.6rem;
    }
}

.subscribe-button-holder {
    display: flex;
    justify-content: flex-end;
}
</style>
